import {observer} from "mobx-react-lite";
import {SortableItemProps} from "../../../../entity/props/document/sortable-item-props";
import {useSortable} from "@dnd-kit/sortable";
import React, {useEffect, useState} from "react";
import {Item} from "./Item";

import '../../../../assets/css/document/accordion-document.css';

const SortableItem = (props: SortableItemProps): JSX.Element => {

    const id = props.id;
    const {setNodeRef, setActivatorNodeRef, listeners, isSorting, transform, transition} = useSortable({id});
    const [isMounted, setIsMounted] = useState(false);
    const mountedWhileDragging = props.dragging && !isMounted;

    useEffect(() => {
        const timeout = setTimeout(() => setIsMounted(true), 500);
        return (): void => clearTimeout(timeout);
    }, []);

    const getParentClassName = (): string => {
        let className = 'wrapper';

        if(props.dragging)
            className = className + ' dragging';

        if (isSorting)
            className = className + ' sorting';

        if (mountedWhileDragging)
            className = className + ' fadeIn';

        if (props.selected)
            className = className + ' selected';

        return className;
    }

    const getItemClassName = (): string => {
        let className = 'document-item withHandle';

        if(props.dragging)
            className = className + ' dragging';

        if (props.selected)
            className = className + ' selected';

        return className;
    }

    return (
        <Item
            ref={setNodeRef}
            project={props.project}
            parentClassName={getParentClassName()}
            parentStyle={{
                transition: transition,
                '--translate-x': transform ? `${Math.round(transform.x)}px` : undefined,
                '--translate-y': transform ? `${Math.round(transform.y)}px` : undefined,
                '--scale-x': transform?.scaleX ? `${transform.scaleX}` : undefined,
                '--scale-y': transform?.scaleY ? `${transform.scaleY}` : undefined,
            } as React.CSSProperties}
            itemClassName={getItemClassName()}
            dragOverlay={false}
            handleProps={{ref: setActivatorNodeRef}}
            handle
            listeners={listeners}
            onSelect={props.onSelect ? (): void => props.onSelect(id.toString()) : undefined}
            selected={props.selected}
            value={id}
            items={props.items}
            setItems={props.setItems}
            documentId={props.id}/>
    );
}

export default observer(SortableItem);
